import { fetchAuthSession } from '@aws-amplify/auth';
import { ResourcesConfig } from '@aws-amplify/core';
import { Amplify } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import App from './App';
import { resolveAdminAuthIdentifiers } from './previewAuthConfig';
import './styles/index.css';

const authIdentifiers = resolveAdminAuthIdentifiers(window.location.hostname, {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  userPoolClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID as string,
  identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID as string,
});

const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    allowGuestAccess: false,
    // The dedicated Admin dev pool requires MFA, so it cannot support the
    // shared synthetic preview login. Preview Admin uses the same public dev
    // EHR pool/client as the EHR preview; its backend still requires a seeded
    // active AdminUser row and enforces the normal Admin permission matrix.
    userPoolId: authIdentifiers.userPoolId,
    userPoolClientId: authIdentifiers.userPoolClientId,
    identityPoolId: authIdentifiers.identityPoolId,
  },
};

Amplify.configure(
  {
    Auth: authConfig,
    API: {
      REST: {
        api: {
          endpoint: import.meta.env.VITE_CHIROUP_API as string,
        },
        exportApi: {
          endpoint: import.meta.env.VITE_ADMIN_EXPORT_API as string,
        },
        connectionApi: {
          endpoint: import.meta.env.VITE_CONNECTION_API as string,
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async () => {
          const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();

          return {
            Authorization: `Bearer ${authToken}`,
          };
        },
        retryStrategy: {
          strategy: 'no-retry',
        },
      },
    },
  }
);

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
